import React, { useState, useEffect } from 'react';
import AdSense from "react-adsense";
import axios from 'axios';
import { Helmet } from "react-helmet";
import { FaMicrophone, FaStop } from 'react-icons/fa';
import { alert_error, alert_success } from "../../../AppContext.js";
import { useParams, useNavigate } from 'react-router-dom';
import { RingLoader } from "react-spinners";
import { TiTick } from 'react-icons/ti';
import { MdVolumeUp } from 'react-icons/md';
import { Cookies } from '../../../index.js';
import History from "./history_main.jsx";
import Options from "../options.jsx";
import Select from 'react-select';
import classNames from "classnames";
const Orders_home = () => {
    const { slug_1 } = useParams();
    const { slug_2 } = useParams();
    const { slug_3 } = useParams();
    const [userOption, setUserOption] = useState("changeCard");
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    return (
        <>
            {slug_2 === "home" && (
                <Options />
            )}
            {(slug_1 === "history" && slug_2 != "home") && (
                <History />
            )}
        </>
    );
};

export default Orders_home;
